import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  name: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.path ? `https://kissxsister-anime.com${item.path}` : undefined,
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <nav aria-label="面包屑导航" className="flex items-center gap-2 text-sm font-body py-4">
        {items.map((item, index) => (
          <span key={index} className="flex items-center gap-2">
            {index > 0 && (
              <span className="w-4 h-4 flex items-center justify-center text-foreground-400">
                <i className="ri-arrow-right-s-line text-sm"></i>
              </span>
            )}
            {item.path && index < items.length - 1 ? (
              <Link to={item.path} className="text-foreground-500 hover:text-primary-500 transition-colors">
                {item.name}
              </Link>
            ) : (
              <span className={index === items.length - 1 ? 'text-foreground-900 font-medium' : 'text-foreground-500'}>
                {item.name}
              </span>
            )}
          </span>
        ))}
      </nav>
    </>
  );
}